<script setup lang="ts"></script>
<template>
   <div class="clusters"><RouterView></RouterView></div>
</template>
